<router-outlet></router-outlet>
@if (showStickyBar()) {
  <app-sticky-bar (scrollToTop)="onScrollToTop()" ></app-sticky-bar>
}
